import { render } from "./LandTypeControl.vue?vue&type=template&id=90c7fe9a&ts=true"
import script from "./LandTypeControl.vue?vue&type=script&lang=ts"
export * from "./LandTypeControl.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__